// FETCH ALL APPLICATION LIST
export const FETCH_APPLICATION_LIST_SUCCESS = "FETCH_APPLICATION_LIST_SUCCESS";
export const FETCH_APPLICATION_LIST_ERROR = "FETCH_APPLICATION_LIST_ERROR";

//PAGE_CHANGE Actions
export const APPLICATION_PAGE_CHANGE = "APPLICATION_PAGE_CHANGE"

//LIMIT_CHANGE Actions
export const APPLICATION_LIMIT_CHANGE = "APPLICATION_LIMIT_CHANGE"